import axios from "axios"
import { Utils } from "../../utils"

export class ExternalService {

    static async getCEP(cep: string) {
        return axios.get(`https://viacep.com.br/ws/${Utils.onlyDigits(cep)}/json/`)
    }

    static async getCNPJ(cnpj: string) {
        return axios.get(`https://receitaws.com.br/v1/cnpj/${Utils.onlyDigits(cnpj)}`)
    }
}